import React from 'react';
import ListBoxView from './ListBoxView';
import { ListBoxContainerProps, ListBoxData } from './types';
import { useListBoxState } from './useListBoxState';

function ForwardedListBoxContainer<T extends ListBoxData = ListBoxData>(
  props: ListBoxContainerProps<T>,
  ref: React.ForwardedRef<HTMLUListElement>,
): React.ReactElement | null {
  const state = useListBoxState(props);

  return <ListBoxView ref={ref} state={state} {...props} />;
}

const ListBoxContainer = React.forwardRef(ForwardedListBoxContainer) as <
  T extends ListBoxData = ListBoxData,
>(
  props: ListBoxContainerProps<T> & { ref?: React.Ref<HTMLUListElement> },
) => React.ReactElement | null;

export default ListBoxContainer;
